import type { StepData } from '@savvy-kit/patterns/stepper';

export const CUSTODIAN_TRANSFER_SUCCESS_STEPS: StepData[] = [
  {
    label: 'Accounts are set up',
    description: 'Your advisor sets up accounts based on your conversation. You confirm details in the next steps.',
  },
  {
    label: 'Personal details confirmed',
    description: "Most of your information is already filled in\u2014you'll just need to review and confirm.",
  },
  {
    label: 'Your assets are preparing for transfer',
    description: 'Your accounts remain visible throughout the transfer flow.',
  },
  {
    label: 'Your accounts are ready',
    description: 'Continue working with your advisor to manage and grow your portfolio.',
  },
];

export const TRANSFER_TIMELINE_STEPS: StepData[] = [
  { label: 'Confirm details', description: 'Submitted' },
  { label: 'In review', description: 'Awaiting Savvy Ops' },
  { label: 'Asset transfer', description: 'Takes 7-10 days' },
  { label: 'Accounts ready' },
];

export const ACCOUNT_OPENING_SUCCESS_STEPS: StepData[] = [
  { label: 'Account details confirmed', description: 'Your account details have been submitted.' },
  { label: 'Personal details confirmed', description: 'Your information and signed agreements have been received.' },
  {
    label: 'Your accounts are being opened',
    description: 'Savvy is processing your account opening request. No assets are transferring in.',
  },
  { label: 'Your accounts are ready', description: 'Your advisor will let you know when your accounts are ready.' },
];

export const ACCOUNT_OPENING_TIMELINE_STEPS: StepData[] = [
  { label: 'Confirm details', description: 'Submitted' },
  { label: 'In review', description: 'Awaiting Savvy Ops' },
  { label: 'Account opening', description: 'Awaiting custodian confirmation' },
  { label: 'Accounts ready' },
];
